import type { HttpClient } from '../http/types';
import type {
  CreateManualTimeEntryPayload,
  ProjectTimesheetFilters,
  TimeEntry,
  TimeEntryListFilters,
  TimeEntryPage,
  TimerSession,
  TimesheetFilters,
  TimesheetSummary,
} from '../types/timesheet';
import { ENDPOINTS } from './endpoints';

export function createTimesheetApi(http: HttpClient) {
  return {
    /** POST /projects/:projectId/timer — inicia o timer da task (um por identidade). */
    startTimer: (projectId: string, taskId: string) =>
      http.post<TimerSession>(ENDPOINTS.timesheet.timerStart(projectId), { taskId }),

    /** POST /timer/:timerSessionId/stop — encerra a sessão e devolve o apontamento criado. */
    stopTimer: (timerSessionId: string) =>
      http.post<TimeEntry>(ENDPOINTS.timesheet.timerStop(timerSessionId)),

    /** POST /timer/:timerSessionId/discard — descarta a sessão sem gerar apontamento. */
    discardTimer: (timerSessionId: string) =>
      http.post<TimerSession>(ENDPOINTS.timesheet.timerDiscard(timerSessionId)),

    /** GET /timer/current — sessão em andamento da identidade logada. */
    currentTimer: () => http.get<TimerSession | null>(ENDPOINTS.timesheet.timerCurrent),

    summary: (projectId: string, filters?: ProjectTimesheetFilters) =>
      http.get<TimesheetSummary[]>(ENDPOINTS.timesheet.project(projectId), {
        query: filters ? { ...filters } : undefined,
      }),

    mySummary: (filters: TimesheetFilters) =>
      http.get<TimesheetSummary[]>(ENDPOINTS.timesheet.me, { query: { ...filters } }),

    listEntries: (projectId: string, filters?: TimeEntryListFilters) =>
      http.get<TimeEntryPage>(ENDPOINTS.timesheet.entries(projectId), {
        query: filters ? { ...filters } : undefined,
      }),

    createManualEntry: (projectId: string, payload: CreateManualTimeEntryPayload) =>
      http.post<TimeEntry>(ENDPOINTS.timesheet.entries(projectId), payload),

    updateEntry: (id: string, payload: Partial<CreateManualTimeEntryPayload>) =>
      http.patch<TimeEntry>(ENDPOINTS.timesheet.entryById(id), payload),

    removeEntry: (id: string) => http.delete<void>(ENDPOINTS.timesheet.entryById(id)),

    /** Auditoria gerencial de horas (PRJ-106 / PRJ-111). */
    audit: (filters: TimesheetFilters) =>
      http.get<TimeEntry[]>(ENDPOINTS.timesheet.audit, { query: { ...filters } }),
  };
}

export type TimesheetApi = ReturnType<typeof createTimesheetApi>;
